import React from 'react'
import imagePeople1 from "../../../../images/people-1.jpg";
import imagePeople2 from "../../../../images/people-2.jpg";
import imagePeople3 from "../../../../images/people-3.jpg";

const Testimonials  = () => {
    return (
        <section>
            <div className="box more-space">
                <div className="text-center">
                    <h2>Co nám o Mooveez napsali studenti angličtiny</h2>
                </div>
                <div className="box-slide">
                    <div className="col-3 people-box">
                        <img src={imagePeople1} alt=""/>
                            <p>
                                Kvůli pracovnímu vytížení se nemohu účastnit pravidelných kurzů angličtiny, ale vím, že svou angličtinu potřebuji udržovat a rozvíjet. Mooveez mi to umožňuje příjemně a zábavně, kdykoliv mám zrovna čas.
                            </p>
                            <p>
                                <strong>Pierre, Lyon</strong>
                            </p>
                    </div>
                    <div className="col-3 people-box">
                        <img src={imagePeople2} alt=""/>
                            <p>
                                Na kurzech jsem se většinou styděla mluvit. Na Mooveez mě baví, že si v pohodě lehnu do postele a v klidu si hraju s filmy. Po čase cítím, že se moje angličtina zlepšuje. A musím říct, že není nic lepšího než pocit, že rozumím dokonale filmu v originále!
                            </p>
                            <p>
                                <strong>Alejandra, Madrid</strong>
                            </p>
                    </div>
                    <div className="col-3 people-box">
                        <img src={imagePeople3} alt=""/>
                            <p>
                                Moje angličtina nebyla úplně špatná a už jsem těžko hledala motivaci, abych někam chodila a ještě ji zlepšovala. Když jsem objevila Mooveez bylo to pro mě to pravé, protože koukám na seriály, kterým dokonale rozumím a postupně zjištuju jak automaticky používám fráze z filmu v běžném životě a zní to jako by to řekla Angličanka.
                            </p>
                            <p>
                                <strong>Jana, Praha</strong>
                            </p>
                    </div>
                    <div className="cl"><br/></div>
                </div>
            </div>
        </section>
    );
}

export default Testimonials;


// WEBPACK FOOTER //
// ./src/components/company/testimonials/view/Testimonials.jsx